import React, { Component } from "react";
import { berRatings } from "../helpers/Lists.js";

interface IProps {
  label?: any;
  selectedber?: string;
  classes?: string;
  onChange(v: any): void;
  onBlur?(): void;
}

export class BerSelect extends Component<IProps, any> {
  render() {
    return (
      <div className="grid justify-c  full-width">
        {this.props.label && <label htmlFor="ber">{this.props.label}</label>}
        <select
          name="ber"
          id="ber"
          aria-required="true"
          aria-invalid="false"
          className={this.props.classes ?? "  full-width"}
          onChange={this.props.onChange}
        >
          <option
            value=""
            selected={!this.props.selectedber}
            className="placeholder"
          >
            Select
          </option>
          {berRatings.map((l) => {
            return (
              <option
                key={"ber-" + l.name}
                value={l.name}
                selected={l.name === this.props.selectedber}
              >
                {l.name}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}
